import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './ToDoListElement.scss'

import { Link } from 'react-router-dom'
import { Button } from '../Button'
import Media from 'react-media'

const ToDoListElement = props => {
	let { title, desc, link, path, completed, icon } = props

	if (path) {
		return (
			<Link to={path} styleName="element">
				<div
					styleName="symbol"
					className={completed ? styles.green : ''}
				>
					<i className="material-icons">
						{completed ? 'done' : 'clear'}
					</i>
				</div>
				<div styleName="content">
					<div styleName={completed ? 'title-striked' : 'title'}>
						{title}
					</div>
					<div styleName={completed ? 'desc-grayed-out' : 'desc'}>
						{desc}
					</div>
				</div>
				<Media query={{ minWidth: 480 }}>
					<div styleName={completed ? 'nav-grayed-out' : 'nav'}>
						<Button
							type={'ghost'}
							icon={icon ? icon : 'navigate_next'}
						/>
					</div>
				</Media>
			</Link>
		)
	}
	if (link) {
		return (
			<a href={link} styleName="element">
				<div
					styleName="symbol"
					className={completed ? styles.green : ''}
				>
					<i className="material-icons">
						{completed ? 'done' : 'clear'}
					</i>
				</div>
				<div styleName="content">
					<div styleName={completed ? 'title-striked' : 'title'}>
						{title}
					</div>
					<div styleName={completed ? 'desc-grayed-out' : 'desc'}>
						{desc}
					</div>
				</div>
				<Media query={{ minWidth: 480 }}>
					<div styleName={completed ? 'nav-grayed-out' : 'nav'}>
						<Button type={'ghost'} icon={'navigate_next'} />
					</div>
				</Media>
			</a>
		)
	}
	return (
		<div styleName="element">
			<div styleName="symbol" className={completed ? styles.green : ''}>
				<i className="material-icons">
					{completed ? 'done' : 'clear'}
				</i>
			</div>
			<div styleName="content">
				<div styleName={completed ? 'title-striked' : 'title'}>
					{title}
				</div>
				<div styleName={completed ? 'desc-grayed-out' : 'desc'}>
					{desc}
				</div>
			</div>
			<Media query={{ minWidth: 480 }}>
				<div styleName={completed ? 'nav-grayed-out' : 'nav'}>
					<Button type={'ghost'} icon={icon ? icon : 'navigate_next'}>
						Cancel{' '}
					</Button>
				</div>
			</Media>
		</div>
	)
}
ToDoListElement.propTypes = {
	title: React.PropTypes.string,
	desc: React.PropTypes.oneOfType([
		React.PropTypes.string,
		React.PropTypes.node
	])
}

export default CSSModules(ToDoListElement, styles)



// WEBPACK FOOTER //
// /opt/build/repo/packages/components/Layout/ToDoListElement.js